import React, { useEffect, useRef } from "react";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

const SubmitModal = ({ isOpen, toggle, candidate, sendAnyResponse, endMyExam }) => {
  const endExam = useRef();
  const continueExam = useRef();
  const onEnd = () => {
    if (!isOpen) return;
    // endMyExam saves pending answers and waits for the queue before grading.
    endMyExam(candidate.id, Number(localStorage.getItem('timeSpent')));
  };

  const setOptionOnKeyboardPress = (value) => {
    switch (value) {
      case "y":
      case "Y":
          onEnd();
        break;
      case "r":
        case "R":
          toggle();
        break;
      default:
        break;
    }
  };

  const handleKeyDown = e => {
    setOptionOnKeyboardPress(e.key);
  }

  // (e) => {
  //   setOptionOnKeyboardPress(e.key);
  // }

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);
  // }, []);


  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  return (
    <div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>SUBMIT EXAM CONFIRMATION</ModalHeader>
        <ModalBody className=" font-weight-bold">
          <p>Dear {candidate?.name},</p>
          <p>You are about to end your exam, this action cannot be reversed.</p>
          <p>Total Questions attempted is {candidate?.totalAttempted}</p>
          <p>
            Press <span className="text-success">R</span> to continue exam or
            press <span className="text-danger">Y</span> to end exam.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button ref={endExam} color="danger" onClick={onEnd}>
            End Exam
          </Button>{" "}
          <Button ref={continueExam} color="success" onClick={toggle}>
            Continue Exam
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

// const mapStateToProps = state => {
//   return { candidate: }
// }

export default SubmitModal;
// export default connect(null, { endMyExam })(SubmitModal);
